import { connect } from 'react-redux'

import Dashboard, { IStateProps, IDispatchProps, IOwnProps } from './Dashboard'
import { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    columns: state.Dashboard.columns,
    isLogged: state.Auth.isLogged,
  }
}

function mapDispatchToProps(): IDispatchProps {
  return {}
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard)
